import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { take } from 'rxjs/operators';
import { SvgIconService } from '../../../../../components/common/svg-icon/svg-icon.service';

/**
 * LocalMarketDataInvestment Widget
 */
@Component({
  selector: 'local-market-data-investment-widget',
  templateUrl: './local-market-data-investment-widget.component.html',
  styleUrls: ['./local-market-data-investment-widget.component.scss', '../../common/css/general.scss']
})
export class LocalMarketDataInvestmentWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Reference list data
   */
  reflistDropDown = {};

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector, private svgIconService: SvgIconService) {
    super(injector, 'localMarketDataInvestment', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();

    this.reflistDropDown['ref_list_dropdown'] = [
      {
        "oid": 0,
        "additionalDescription": 0,
        "description": "",
        "parentNo": null,
      },
      {
        "oid": 1,
        "additionalDescription": 1,
        "description": "",
        "parentNo": null,
      },
      {
        "oid": 2,
        "additionalDescription": 2,
        "description": "",
        "parentNo": null,
      },
      {
        "oid": 3,
        "additionalDescription": 3,
        "description": "",
        "parentNo": null,
      }
    ];

    this.widgetService.loadReflist('ref_l3_local_market_data_arrows').subscribe((reflistsData: any) => {
      this.reflistDropDown['ref_l3_local_market_data_arrows'] = reflistsData;
    });
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("localMarketDataInvestment", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('localMarketDataInvestment').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('localMarketDataInvestment', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * If you are using svg-icon in your widgets, these will have to be loaded, which happens independent of the RD loading logic.
   * Especially at print, this can lead to race conditions where the widget data is loaded, but the svg icons aren't.
   * Therefore, they can be pre-loaded in this method, which should be overridden in the widget class
   * @returns
   */
  protected preloadSvgIcons(): Promise<any> {
    return Promise.all([
      this.svgIconService.loadSvg('./assets/icons/caret-up-outline.svg'),
      this.svgIconService.loadSvg('./assets/icons/caret-down-outline.svg'),
      this.svgIconService.loadSvg('./assets/icons/caret-forward-outline.svg')
    ]).then(() => new Promise((resolve) => {
      //Give them time to render
      setTimeout(() => {
        resolve(null);
      }, 100);
    }));
  }
}
